
import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group fixed bottom-4 right-4 z-[9999] w-full max-w-xs"
      richColors={true}
      position="bottom-right"
      expand={false}
      closeButton={true}
      offset="16px"
      gap={8}
      toastOptions={{
        duration: 5000,
        className: "w-full bg-background text-foreground border-border shadow-lg",
        classNames: {
          toast: "group toast relative flex w-full items-center p-4 rounded-lg border border-border",
          title: "text-sm font-semibold",
          description: "text-sm text-muted-foreground mt-1",
          actionButton: "bg-primary text-primary-foreground",
          cancelButton: "bg-muted text-muted-foreground",
          closeButton: "absolute right-2 top-2 opacity-70 hover:opacity-100",
          success: "bg-green-50 dark:bg-green-900/20 text-green-800 dark:text-green-300 border-green-200 dark:border-green-800",
          error: "bg-destructive/15 text-destructive border-destructive/30",
          info: "bg-blue-50 dark:bg-blue-900/20 text-blue-800 dark:text-blue-300 border-blue-200 dark:border-blue-800",
          warning: "bg-yellow-50 dark:bg-yellow-900/20 text-yellow-800 dark:text-yellow-300 border-yellow-200 dark:border-yellow-800",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
